<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-11-03 15:46:22
-->
<template>
	<div class="flex-row-align-center">
		<div :class="['state_icon', row[column.status_field] === '1' ? 'success' : 'info']"></div>
		<div class="ml-10 yx-color-text-primary">{{ status }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	name: 'promoteStateCell',
	mixins: [mixin],
	computed: {
		status() {
			return this.row[this.column.status_field] === '1' ? '正常' : '已禁用';
		},
	},
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.info {
	background-color: @color-info;
}
</style>
